import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';

import CustomDropdown from '@components/CustomDropdown';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';

import UploadImage from '@features/designTool/components/UploadImage';
import MaterialColorAddV2 from '@features/materials/components/MaterialColorAddV2';

import { getBrands } from '@store/design/action';
import { fetchBrandingDetails, fetchTrimsDetails } from '@store/material/action';
import { getAllBrands, getBrandingDetails, getTrimsDetails } from '@store/reducers';

import { fetchMaterialUnitType } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import {
	areEqual,
	docType,
	enumObj,
	fetchCategoriesForTrimsOrAccessories,
	fetchMaterialNumberForTrimsOrAccessories,
	fetchSupplierByMaterialType,
	fetchTagsForTrimsOrAccessories,
	generateMaterialNameForTrimsOrAccessories,
	isValidFormForBinding,
	MATERIAL_TAG_TYPE,
	MATERIAL_TITLE_NAME
} from '@utils/MaterialsUtil';
import { _getKey, isValidFile, validateFloatNumber } from '@utils/Util';

import { BASE_URL, MATERIALS_TYPE } from '@/constants/constant';

const TrimsAndAccessories = ({
	materialData,
	onclose,
	renderFrom,
	isAdd,
	viewType,
	title = '',
	productId,
	onSelectItem
}) => {
	const [show, setShow] = useState(true);
	const [multipleImageData, setMultipleImageData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [materialId, setMaterialId] = useState(null);
	const [errors, setErrors] = useState({});
	const [selectedItem, setSelectedItem] = useState({});
	const [pricePoint, setPricePoint] = useState({});

	const [categories, setCategories] = useState([]);
	const [selectedCategories, setSelectedCategories] = useState(null);

	const [techniqueList, setTechniqueList] = useState([]);
	const [selectedTechnique, setSelectedTechnique] = useState(null);

	const [materialQualityList, setMaterialQualityList] = useState([]);
	const [selectedMaterialQuality, setSelectedMaterialQuality] = useState(null);

	const [sustainabilityList, setSustainabilityList] = useState([]);
	const [selectedSustainability, setSelectedSustainability] = useState(null);

	const [selectedSpecificBrand, setSelectedSpecificBrand] = useState({});

	const [materialNumberList, setMaterialNumberList] = useState([]);
	const [selectedMaterialNumber, setSelectedMaterialNumber] = useState(null);

	const [duplicateItem, setDuplicateItem] = useState({});
	const [duplicateValueSet, setDuplicateValueSet] = useState(true);

	/* ------------- supplier ---------------------- */
	const [isShowSupplier, setIsShowSupplier] = useState(false);
	const [price, setPrice] = useState(null);
	const [pricePerUnit, setPricePerUnit] = useState(null);
	const [allUnitTypes, setAllUnitTypes] = useState([]);
	const [referenceNumber, setReferenceNumber] = useState('');
	const [selectedBrands, setSelectedBrands] = useState([]);
	const [selectedSupplier, setSelectedSupplier] = useState(null);
	const [suppliers, setSuppliers] = useState([]);
	const [leadTimeInDays, setLeadTimeInDays] = useState(null);
	const [moq, setMoq] = useState(null);
	const [oldSupplierId, setOldSupplierId] = useState(null);
	const [duplicateSupplier, setDuplicateSupplier] = useState({});
	const [colorId, setColorId] = useState(null);
	const [colorType, setColorType] = useState('SOLID');
	const [colorDTO, setColorDTO] = useState({});
	const [colorGroupIdList, setColorGroupIdList] = useState([]);
	const [selectedGroupColorList, setSelectedGroupColorList] = useState([]);
	const [selectedPantoneColorList, setSelectedPantoneColorList] = useState([]);

	const pricePointList = [
		{ id: 'LOW', text: 'LOW', value: 'LOW', label: 'Regular' },
		{ id: 'MID', text: 'MID', value: 'MID', label: 'Mid' },
		{ id: 'HIGH', text: 'HIGH', value: 'HIGH', label: 'Premium' }
	];

	const dispatch = useDispatch();
	const location = useLocation();

	const queryParams = new URLSearchParams(location.search);
	const materialType = queryParams.get('type');

	let trimsAndAccessoriesDetails = useSelector(
		materialType === 'TRIMS' ? getTrimsDetails : getBrandingDetails
	);
	if (isAdd) trimsAndAccessoriesDetails = null;

	useEffect(() => {
		const itemDetails = trimsAndAccessoriesDetails?.data;

		if (itemDetails !== undefined && itemDetails !== null) {
			const supplier = itemDetails?.supplier;
			setMaterialId(itemDetails?.id);
			setColorId(itemDetails?.materialColorResponse?.colorResponse?.id);
			setSelectedGroupColorList(itemDetails?.materialColorResponse?.colorGroupResponseList);
			setColorType(itemDetails?.materialColorResponse?.colorType?.constant);
			if (Object.keys(itemDetails.materialColorResponse.colorResponse).length > 0) {
				if (itemDetails?.materialColorResponse?.colorResponse?.compositeColorList) {
					setSelectedPantoneColorList(
						itemDetails?.materialColorResponse?.colorResponse?.compositeColorList
					);
				} else {
					setSelectedPantoneColorList([itemDetails?.materialColorResponse?.colorResponse]);
				}
			} else {
				setSelectedPantoneColorList([]);
			}
			if (itemDetails?.documentResponseList) {
				setMultipleImageData(itemDetails.documentResponseList);
			}

			let itemInfo = {
				...selectedItem,
				materialType: itemDetails?.materialType,
				colorResponseList: itemDetails?.colorResponseList || [],
				description: itemDetails?.description || '',
				documentId: itemDetails?.documentId || null,
				id: itemDetails?.id,
				widthFromEdges: itemDetails?.widthFromEdges,
				diameter: itemDetails?.diameter,
				widthInside: itemDetails?.widthInside,
				zipperNumber: itemDetails?.zipperNumber,
				length: itemDetails?.length,
				height: itemDetails?.height,
				numberOfHole: itemDetails?.numberOfHole,
				details: itemDetails?.details,
				materialNumber: itemDetails?.materialNumber
			};

			setSelectedItem(itemInfo);

			const subCategory = categories.find((item) => item.id === itemDetails?.subCategoryType?.id);
			setSelectedCategories(subCategory);
			getAllMaterialNumber(itemDetails?.subCategoryType?.id);
			const technique = techniqueList.find((item) => item.id === itemDetails?.technique?.id);
			setSelectedTechnique(technique);
			const materialQuality = materialQualityList.find(
				(item) => item.id === itemDetails?.materialQuality?.id
			);
			setSelectedMaterialQuality(materialQuality);
			const sustainability = sustainabilityList.find(
				(item) => item.id === itemDetails?.sustainability?.id
			);
			setSelectedSustainability(sustainability);
			const pricePointItem = pricePointList.find((item) => item.id === itemDetails?.pricePoint);
			setPricePoint(pricePointItem);
			let materialNumberObj = null;
			if (itemDetails?.materialNumber !== undefined) {
				materialNumberObj = {
					id: itemDetails?.materialNumber,
					value: itemDetails?.materialNumber
				};
				setSelectedMaterialNumber(materialNumberObj);
			}

			let specificBrand;

			if (supplier && suppliers) {
				setIsShowSupplier(true);
				setOldSupplierId(supplier.supplierId);
				setReferenceNumber(supplier.referenceNumber);
				setPrice(supplier.price);
				setPricePerUnit(supplier.pricePerUnit);
				setLeadTimeInDays(supplier.leadTimeInDays);
				setMoq(supplier.moq);
				let brands = [];
				for (let item of supplier.brandResponseList) {
					brands.push({
						id: item.id,
						text: item.name,
						value: item.id,
						label: item.name
					});
				}
				const specificBrandResponse = itemDetails?.specificBrandResponse;
				if (specificBrandResponse !== undefined)
					specificBrand = {
						id: specificBrandResponse?.id,
						text: specificBrandResponse?.name,
						value: specificBrandResponse?.id,
						label: specificBrandResponse?.name
					};
				setSelectedSpecificBrand(specificBrand);
				setSelectedBrands(brands);
			}

			if (
				viewType === 'Duplicate' &&
				categories &&
				duplicateValueSet &&
				itemDetails?.id === materialData.id
			) {
				setOldSupplierId(null);
				setColorDTO({});
				if (itemDetails?.colorResponseList?.length > 0) {
					let colorResponse = itemDetails?.colorResponseList[0];
					setColorDTO(colorResponse);
				}

				let dupItem = setTrimsAndAccessories(
					itemInfo,
					subCategory,
					technique,
					materialQuality,
					sustainability,
					specificBrand,
					pricePointItem,
					itemDetails?.documentResponseList,
					materialNumberObj
				);
				let brandIdList = supplier?.brandResponseList.map((brand) => brand.id);
				let dupSupplier = {
					supplierId: supplier?.supplierId || null,
					referenceNumber: supplier?.referenceNumber || '',
					price: supplier?.price || null,
					pricePerUnit: supplier?.pricePerUnit || null,
					leadTimeInDays: supplier?.leadTimeInDays || null,
					moq: supplier?.moq || null,
					brandIds: brandIdList || []
				};
				setDuplicateItem(dupItem);
				setDuplicateSupplier(dupSupplier);
				if (supplier && selectedCategories) setDuplicateValueSet(false);
			}
			setIsLoading(false);
		} else {
			setIsLoading(false);
		}
	}, [trimsAndAccessoriesDetails, categories]);

	useEffect(() => {
		let supplier = trimsAndAccessoriesDetails?.data?.supplier;
		if (supplier && suppliers) supplierSet(supplier);
	}, [suppliers, trimsAndAccessoriesDetails?.data?.supplier]);

	useEffect(() => {
		setIsLoading(true);
		if ([MATERIAL_TITLE_NAME.TRIMS, MATERIAL_TITLE_NAME.BRANDING].includes(title)) {
			fetchTagsForTrimsOrAccessories('', MATERIAL_TAG_TYPE.TECHNIQUE, setTechniqueList);
			fetchTagsForTrimsOrAccessories('', MATERIAL_TAG_TYPE.MATERIAL_QUALITY, setMaterialQualityList);
			fetchTagsForTrimsOrAccessories('', MATERIAL_TAG_TYPE.SUSTAINABILITY, setSustainabilityList);
		}
		if (title === MATERIAL_TITLE_NAME.TRIMS) {
			fetchCategoriesForTrimsOrAccessories('trimsSubCategories', setCategories);
		} else if (title === MATERIAL_TITLE_NAME.BRANDING) {
			fetchCategoriesForTrimsOrAccessories('brandingSubCategories', setCategories);
		}

		if (materialData !== null && materialData !== undefined) {
			fetchSupplierByMaterialType(undefined, title, setIsLoading, setSuppliers).finally(
				fetchMaterialDetails()
			);
		} else {
			fetchSupplierByMaterialType(undefined, title, setIsLoading, setSuppliers).finally();
		}
	}, [materialData]);

	const supplierSet = (supplier) => {
		let supplierNameInfo = suppliers.find((obj) => obj.id === supplier.supplierId);
		if (supplierNameInfo) {
			let item = { id: supplierNameInfo.id, title: 'Supplier', value: supplierNameInfo.value };
			setSelectedSupplier(item);
		}
	};

	const handleClose = (value) => {
		setSelectedItem(null);
		setShow(false);
		onclose(value);
	};
	const multipleImageUpload = async (data) => {
		setIsLoading(true);
		await ApiClient.POST('getBulkUploadMaterialDoc', data)
			.then(({ data }) => {
				setIsLoading(false);
				if (data) {
					let docType = data.map((imageInfo) => imageInfo.docType);
					let tmpArray = multipleImageData?.filter((obj) => !docType.includes(obj.docType));
					if (tmpArray.length > 0) setMultipleImageData([...tmpArray, ...data]);
					else setMultipleImageData(data);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};
	const singleImageUpload = async (imageInfo) => {
		delete imageInfo.productId;
		delete imageInfo.documentGroup;
		if (validateFileSize(imageInfo.size)) {
			imageInfo.entityId = materialData ? materialData?.id : null;
			setIsLoading(true);
			await ApiClient.POST('getUploadMaterialDoc', imageInfo)
				.then(({ data }) => {
					setIsLoading(false);
					if (data) {
						let tmpArray = multipleImageData?.filter((obj) => data.docType !== obj.docType);

						if (tmpArray?.length > 0) setMultipleImageData([...tmpArray, data]);
						else setMultipleImageData([data]);
					}
				})
				.catch(({ response }) => {
					setIsLoading(false);
					if (response && response.data && response.data.message) {
						toastError(response.data.message);
					} else {
						toastError('Request was unsuccessful.');
					}
				});
		}
	};
	const validateFileSize = (size) => {
		if (size > 1000000) {
			toastError('Please upload file less than 1mb');
			return false;
		} else {
			return true;
		}
	};
	const removeImage = async (docId) => {
		if (materialData?.id)
			await ApiClient.DELETE(
				`${BASE_URL}/material/${materialData?.id}/documents/${docId}`,
				'',
				'',
				true
			)
				.then(({ data }) => {
					setIsLoading(false);
					if (data && data.success) {
						toastSuccess(data.message);
						imageRemoveInArray(docId);
					}
				})
				.catch(({ response }) => {
					setIsLoading(false);
					if (response && response.data && response.data.message) {
						toastError(response.data.message);
					} else {
						toastError('Request was unsuccessful.');
					}
				});
		else {
			imageRemoveInArray(docId);
		}
	};
	const imageRemoveInArray = (docId) => {
		let tmpArray = multipleImageData?.filter((obj) => docId !== obj.id);
		setMultipleImageData(tmpArray);
	};
	const getImageData = (multipleImageData, documentType) => {
		return multipleImageData?.find((item) => item.docType === documentType);
	};

	const isValidFormForSubmit = (trimsAndAccessoriesInfo) => {
		if (trimsAndAccessoriesInfo?.categoryId === undefined) {
			setErrors((prevState) => ({ ...prevState, categoryError: 'Category is required' }));
			return false;
		}
		if (
			trimsAndAccessoriesInfo?.materialQualityTagRequest?.text === undefined ||
			trimsAndAccessoriesInfo?.materialQualityTagRequest?.text.toString().trim() === ''
		) {
			setErrors((prevState) => ({
				...prevState,
				categoryError: undefined,
				materialQualityError: 'Material Quality is required'
			}));
			return false;
		} else {
			setErrors((prevState) => ({
				...prevState,
				categoryError: undefined,
				materialQualityError: undefined
			}));
		}
		if (trimsAndAccessoriesInfo?.colorGroupIdList?.length === 0) {
			setErrors({ colorError: 'Main color is required' });
			return false;
		}

		return true;
	};

	const updatedTrimsAndAccessories = async (urlName, trimsAndAccessoriesInfo, supplierInfo) => {
		trimsAndAccessoriesInfo.colorDTO = colorDTO;
		trimsAndAccessoriesInfo.colorGroupIdList = colorGroupIdList;
		trimsAndAccessoriesInfo.colorType = colorType;
		const isValid = isValidFormForSubmit(trimsAndAccessoriesInfo, supplierInfo);
		if (!isValid) return;
		let trimsAndAccessoriesInfoWithSupplierInfo = {
			trimsAndBrandingRequest: trimsAndAccessoriesInfo,
			supplierMaterialRequest: supplierInfo
		};
		setIsLoading(true);
		await ApiClient.PUT(urlName, trimsAndAccessoriesInfoWithSupplierInfo)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					handleClose('updated');
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const addTrimsAndAccessories = async (urlName, trimsAndAccessoriesInfo, supplierInfo) => {
		trimsAndAccessoriesInfo.colorDTO = colorDTO;
		trimsAndAccessoriesInfo.colorGroupIdList = colorGroupIdList;
		trimsAndAccessoriesInfo.colorType = colorType;
		if (productId) trimsAndAccessoriesInfo.productId = productId;
		trimsAndAccessoriesInfo.materialType =
			title === MATERIAL_TITLE_NAME.TRIMS ? MATERIALS_TYPE.TRIMS : MATERIALS_TYPE.BRANDING;
		trimsAndAccessoriesInfo.addType = viewType;
		const isValid = isValidFormForSubmit(trimsAndAccessoriesInfo, supplierInfo);
		if (!isValid) return;
		let trimsAndAccessoriesInfoWithSupplierInfo = {
			trimsAndBrandingRequest: trimsAndAccessoriesInfo,
			supplierMaterialRequest: supplierInfo
		};
		setIsLoading(true);
		await ApiClient.POST(urlName, trimsAndAccessoriesInfoWithSupplierInfo)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					if (onSelectItem) {
						onSelectItem((data = { id: data.id, value: data.name }));
					}
					handleClose('Add');
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onSubmit = () => {
		const trimsAndBrandingInfo = setTrimsAndAccessories(
			selectedItem,
			selectedCategories,
			selectedTechnique,
			selectedMaterialQuality,
			selectedSustainability,
			selectedSpecificBrand,
			pricePoint,
			multipleImageData,
			selectedMaterialNumber
		);
		const supplierInfo = setSupplierInfo();
		generateMaterialNameForTrimsOrAccessories(selectedCategories, trimsAndBrandingInfo);

		if (viewType === 'Duplicate') {
			if (isDuplicateDataCheck(duplicateItem, trimsAndBrandingInfo, duplicateSupplier, supplierInfo)) {
				toastError('Change the material info to add new ' + title?.toLowerCase());
				return;
			}
			if (title === MATERIAL_TITLE_NAME.TRIMS)
				addTrimsAndAccessories(
					'duplicateTrimsWithSupplier',
					trimsAndBrandingInfo,
					supplierInfo
				).finally();
			else if (title === MATERIAL_TITLE_NAME.BRANDING)
				addTrimsAndAccessories(
					'duplicateBrandingWithSupplier',
					trimsAndBrandingInfo,
					supplierInfo
				).finally();
		} else if (isAdd && title === MATERIAL_TITLE_NAME.TRIMS) {
			addTrimsAndAccessories('addTrimsWithSupplier', trimsAndBrandingInfo, supplierInfo).finally();
		} else if (isAdd && title === MATERIAL_TITLE_NAME.BRANDING) {
			addTrimsAndAccessories('addBrandingWithSupplier', trimsAndBrandingInfo, supplierInfo).finally();
		} else if (!isAdd && title === MATERIAL_TITLE_NAME.TRIMS) {
			updatedTrimsAndAccessories(
				'updateTrimsWithSupplier',
				trimsAndBrandingInfo,
				supplierInfo
			).finally();
		} else if (!isAdd && title === MATERIAL_TITLE_NAME.BRANDING) {
			updatedTrimsAndAccessories(
				'updateBrandingWithSupplier',
				trimsAndBrandingInfo,
				supplierInfo
			).finally();
		}
	};

	const setTrimsAndAccessories = (
		selectedItem,
		selectedCategories,
		selectedTechnique,
		selectedMaterialQuality,
		selectedSustainability,
		specificBrand,
		pricePoint,
		multipleImageData,
		selectedMaterialNumber
	) => {
		let objInfo = { ...selectedItem };
		objInfo.categoryId = selectedCategories?.id;
		objInfo.techniqueTagRequest = { id: selectedTechnique?.id, text: selectedTechnique?.value };
		objInfo.materialQualityTagRequest = {
			id: selectedMaterialQuality?.id,
			text: selectedMaterialQuality?.value
		};
		objInfo.sustainabilityTagRequest = {
			id: selectedSustainability?.id,
			text: selectedSustainability?.value
		};
		objInfo.documentIdList = multipleImageData?.map((item) => item.id);
		objInfo.brandId = specificBrand?.id;
		objInfo.pricePoint = pricePoint?.id;
		objInfo.materialNumber = selectedMaterialNumber?.value;
		return objInfo;
	};

	const setSupplierInfo = () => {
		return {
			price: price ? price : null,
			oldSupplierId,
			pricePerUnit: pricePerUnit ? pricePerUnit : null,
			leadTimeInDays: leadTimeInDays ? leadTimeInDays : null,
			moq: moq ? moq : null,
			referenceNumber,
			brandIds: selectedBrands?.map((item) => item.id),
			materialId,
			supplierId: selectedSupplier ? selectedSupplier.id : null,
			requestedPage: 'MATERIAL'
		};
	};

	const isDuplicateDataCheck = (duplicateItemInfo, itemInfo, duplicateSupplier, supplierInfo) => {
		let isDuplicate = true;
		if (
			duplicateItemInfo?.categoryId !== itemInfo?.categoryId ||
			duplicateItemInfo?.techniqueTagRequest?.id !== itemInfo?.techniqueTagRequest?.id ||
			duplicateItemInfo?.materialQualityTagRequest?.id !== itemInfo?.materialQualityTagRequest?.id ||
			duplicateItemInfo?.sustainabilityTagRequest?.id !== itemInfo?.sustainabilityTagRequest?.id ||
			duplicateItemInfo?.materialNumber !== itemInfo?.materialNumber ||
			duplicateItemInfo?.widthFromEdges !== itemInfo?.widthFromEdges ||
			duplicateItemInfo?.diameter !== itemInfo?.diameter ||
			duplicateItemInfo?.widthInside !== itemInfo?.widthInside ||
			duplicateItemInfo?.zipperNumber !== itemInfo?.zipperNumber ||
			duplicateItemInfo?.length !== itemInfo?.length ||
			duplicateItemInfo?.height !== itemInfo?.height ||
			!areEqual(duplicateItemInfo?.documentIdList, itemInfo?.documentIdList) ||
			// !areEqual(
			// 	duplicateItemInfo?.colorResponseList?.map((colorDTO) => colorDTO?.name),
			// 	colorDTO?.map((colorDTO) => colorDTO?.name)
			// ) ||
			duplicateItemInfo?.brandId !== itemInfo?.brandId ||
			duplicateItemInfo?.pricePoint !== itemInfo?.pricePoint ||
			duplicateSupplier?.supplierId !== supplierInfo?.supplierId ||
			duplicateSupplier?.price !== supplierInfo?.price ||
			duplicateSupplier?.pricePerUnit !== supplierInfo?.pricePerUnit ||
			duplicateSupplier?.leadTimeInDays !== supplierInfo?.leadTimeInDays ||
			duplicateSupplier?.moq !== supplierInfo?.moq ||
			duplicateSupplier?.referenceNumber !== supplierInfo?.referenceNumber ||
			!areEqual(duplicateSupplier?.brandIds, supplierInfo?.brandIds)
		) {
			isDuplicate = false;
		}
		return isDuplicate;
	};

	const fetchMaterialDetails = () => {
		if (materialData !== null && materialData !== undefined) {
			setIsLoading(true);
			if (title === MATERIAL_TITLE_NAME.TRIMS)
				dispatch(fetchTrimsDetails(materialData?.id)).finally(() => {
					setIsLoading(false);
				});
			if (title === MATERIAL_TITLE_NAME.BRANDING)
				dispatch(fetchBrandingDetails(materialData?.id)).finally(() => {
					setIsLoading(false);
				});
		}
	};

	const renderColors = () => {
		return (
			<>
				<MaterialColorAddV2
					colorId={colorId}
					setColorDTO={setColorDTO}
					colorType={colorType}
					setColorType={setColorType}
					setColorGroupIdList={setColorGroupIdList}
					selectedGroupColorList={selectedGroupColorList}
					setSelectedGroupColorList={setSelectedGroupColorList}
					selectedPantoneColorList={selectedPantoneColorList}
					setSelectedPantoneColorList={setSelectedPantoneColorList}
				/>
				{errors?.colorError && <p className="error">{errors?.colorError}</p>}
			</>
		);
	};

	const onFileUpload = (e) => {
		e.preventDefault();
		let files = [];
		let modifiedFileList = [];
		files = [...e.target.files];
		let invalidFiles = files.filter((item) => item.size > 1000000);
		if (invalidFiles.length > 0) {
			toastError('Each image size should be less than 1mb');
			return;
		}
		if (files.length !== 0 && invalidFiles.length === 0) {
			files.forEach((file) => {
				if (file) {
					if (isValidFile(file, 'image')) {
						let data = {
							entityId: materialData ? materialData?.id : null,
							name: file?.name,
							docMimeType: file?.type,
							documentType: 'MATERIAL_DESIGN',
							base64Str: '',
							size: file?.size
						};
						let reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = () => {
							data.base64Str = reader.result;
							modifiedFileList.push(data);
						};
						reader.onerror = function (error) {
							toastError(error);
						};
					}
				}
			});
			setTimeout(() => {
				if (modifiedFileList?.length > 0) {
					multipleImageUpload(modifiedFileList).then().catch();
				}
			}, 100);
		}
	};

	/** this method use for supplier side **/

	useEffect(() => {
		fetchMaterialUnitType().then((res) => {
			setAllUnitTypes(res);
		});
		dispatch(getBrands()).finally(() => {
			setIsLoading(false);
		});
	}, []);

	let brands = useSelector(getAllBrands);
	brands = brands.map((item) => {
		return {
			id: item.id,
			text: item.name,
			value: item.name,
			label: item.name
		};
	});

	const onChangeBrandInfo = (selectedItems) => {
		setSelectedBrands(selectedItems);
	};
	const onItemClick = (item) => {
		setIsShowSupplier(true);
		setSelectedSupplier(item);
	};

	const getAllMaterialNumber = (subCategoryId) => {
		if (title === MATERIAL_TITLE_NAME.TRIMS && subCategoryId !== undefined) {
			fetchMaterialNumberForTrimsOrAccessories(
				'trimsAllMaterialNumber',
				subCategoryId,
				setMaterialNumberList
			);
		} else if (title === MATERIAL_TITLE_NAME.BRANDING && subCategoryId !== undefined) {
			fetchMaterialNumberForTrimsOrAccessories(
				'brandingAllMaterialNumber',
				subCategoryId,
				setMaterialNumberList
			);
		}
	};

	const onSelectForCustomDropDown = (obj, key) => {
		if (obj !== null && obj.value !== null && obj.value.toString().trim() !== '') {
			obj.value = obj.value.toString().trim();
			if (key === MATERIAL_TAG_TYPE.CATEGORY) {
				let updatedItem = { ...selectedItem };
				if (obj?.widthFromEdges === undefined) updatedItem.widthFromEdges = undefined;
				if (obj?.widthInside === undefined) updatedItem.widthInside = undefined;
				if (obj?.diameter === undefined) updatedItem.diameter = undefined;
				if (obj?.length === undefined) updatedItem.length = undefined;
				if (obj?.height === undefined) updatedItem.height = undefined;
				if (obj?.zipperNumber === undefined) updatedItem.zipperNumber = undefined;
				if (obj?.numberOfHole === undefined) updatedItem.numberOfHole = undefined;
				setSelectedItem(updatedItem);
				setSelectedCategories(obj);
				getAllMaterialNumber(obj?.id);
			}
			obj.value = obj?.value.toString().trim();
			if (key === MATERIAL_TAG_TYPE.TECHNIQUE) setSelectedTechnique(obj);
			if (key === MATERIAL_TAG_TYPE.MATERIAL_QUALITY) setSelectedMaterialQuality(obj);
			if (key === MATERIAL_TAG_TYPE.SUSTAINABILITY) setSelectedSustainability(obj);
			if (
				(obj.isAddNew || obj.value === selectedItem?.materialNumber) &&
				key === MATERIAL_TAG_TYPE.MATERIAL_NUMBER
			)
				setSelectedMaterialNumber(obj);
		}
		let errorKey = '';
		if (key === MATERIAL_TAG_TYPE.CATEGORY) errorKey = 'categoryError';
		if (key === MATERIAL_TAG_TYPE.MATERIAL_QUALITY) errorKey = 'materialQualityError';
		// if (key === MATERIAL_TAG_TYPE.SUSTAINABILITY) errorKey = 'sustainabilityError';
		isValidFormForBinding(obj?.value, errorKey, key.toProperCase() + ' is required', setErrors);
	};

	const TrimsOrAccessoriesRender = () => {
		return (
			<div className="row">
				{renderFrom !== enumObj.DESIGNS && (
					<div className="col-md-12">
						<p className="semibold-14 mb-2">{title?.toUpperCase()} DETAILS</p>
					</div>
				)}

				<div className="col-md-6 pr-6">
					<div className="form-group ">
						<label htmlFor="Category">Category*</label>
						<CustomDropdown
							type="addItem"
							title={'Category'}
							isFocus={true}
							onItemClick={(value) => {
								onSelectForCustomDropDown(value, MATERIAL_TAG_TYPE.CATEGORY);
							}}
							toolTipLength={18}
							items={categories}
							selectedItem={selectedCategories?.value}
						/>

						{errors.categoryError && <p className="error">{errors.categoryError}</p>}
					</div>
				</div>
				<div className="col-md-6 pl-6">
					<div className="form-group ">
						<label htmlFor="technique">Technique</label>
						<CustomDropdown
							type="addItem"
							title={'Technique'}
							isFocus={true}
							onItemClick={(value) => {
								onSelectForCustomDropDown(value, MATERIAL_TAG_TYPE.TECHNIQUE);
							}}
							toolTipLength={25}
							items={techniqueList}
							selectedItem={selectedTechnique?.value}
							isAddNew={true}
						/>
					</div>
				</div>
				<div className="col-md-6 pr-6">
					<div className="form-group ">
						<label htmlFor="Category">Material quality*</label>
						<CustomDropdown
							type="addItem"
							title={'Material quality'}
							isFocus={true}
							onItemClick={(value) => {
								onSelectForCustomDropDown(value, MATERIAL_TAG_TYPE.MATERIAL_QUALITY);
							}}
							toolTipLength={25}
							items={materialQualityList}
							selectedItem={selectedMaterialQuality?.value}
							isAddNew={true}
						/>

						{errors.materialQualityError && (
							<p className="error">{errors.materialQualityError}</p>
						)}
					</div>
				</div>
				<div className="col-md-6 pl-6">
					<div className="form-group ">
						<label htmlFor="technique">Sustainability</label>
						<CustomDropdown
							type="addItem"
							title={'Sustainability'}
							isFocus={true}
							onItemClick={(value) => {
								onSelectForCustomDropDown(value, MATERIAL_TAG_TYPE.SUSTAINABILITY);
							}}
							toolTipLength={25}
							items={sustainabilityList}
							selectedItem={selectedSustainability?.value}
							isAddNew={true}
						/>
						{/*{errors.sustainabilityError && <p className="error">{errors.sustainabilityError}</p>}*/}
					</div>
				</div>

				<div className="col-md-12 px-2">
					<div className="row mx-1">
						{selectedCategories?.widthFromEdges && (
							<div className="col-md-4 px-1">
								<div className="form-group weight-column position-relative">
									<label htmlFor="weightFromEdges">Width(Edges)</label>
									<input
										type="number"
										id="weightFromEdges"
										min={0}
										onKeyDown={validateFloatNumber}
										value={selectedItem?.widthFromEdges}
										onChange={(e) =>
											setSelectedItem({
												...selectedItem,
												widthFromEdges: e.target.valueAsNumber || undefined
											})
										}
									/>
									<p className="fabric-type-text regular-14 gray_dark_02">
										{selectedCategories?.widthFromEdges}
									</p>
									{errors.widthFromEdgesError && (
										<p className="error">{errors.widthFromEdgesError}</p>
									)}
								</div>
							</div>
						)}
						{selectedCategories?.length && (
							<div className="col-md-4 px-1">
								<div className="form-group weight-column position-relative">
									<label htmlFor="length">Length</label>
									<input
										type="number"
										id="length"
										min={0}
										onKeyDown={validateFloatNumber}
										value={selectedItem?.length}
										onChange={(e) =>
											setSelectedItem({
												...selectedItem,
												length: e.target.valueAsNumber || undefined
											})
										}
									/>
									<p className="fabric-type-text regular-14 gray_dark_02">
										{selectedCategories?.length}
									</p>
									{errors.lengthError && <p className="error">{errors.lengthError}</p>}
								</div>
							</div>
						)}
						{selectedCategories?.height && (
							<div className="col-md-4 px-1">
								<div className="form-group weight-column position-relative">
									<label htmlFor="length">Height</label>
									<input
										type="number"
										id="height"
										min={0}
										onKeyDown={validateFloatNumber}
										value={selectedItem?.height}
										onChange={(e) =>
											setSelectedItem({
												...selectedItem,
												height: e.target.valueAsNumber || undefined
											})
										}
									/>
									<p className="fabric-type-text regular-14 gray_dark_02">
										{selectedCategories?.height}
									</p>
									{errors.heightError && <p className="error">{errors.heightError}</p>}
								</div>
							</div>
						)}
						{selectedCategories?.widthInside && (
							<div className="col-md-4 px-1">
								<div className="form-group weight-column position-relative">
									<label htmlFor="weightFromEdges">Width(Inside)</label>
									<input
										type="number"
										id="weightFromEdges"
										min={0}
										onKeyDown={validateFloatNumber}
										value={selectedItem?.widthInside}
										onChange={(e) =>
											setSelectedItem({
												...selectedItem,
												widthInside: e.target.valueAsNumber || undefined
											})
										}
									/>
									<p className="fabric-type-text regular-14 gray_dark_02">
										{selectedCategories?.widthInside}
									</p>
									{errors.widthInsideError && (
										<p className="error">{errors.widthInsideError}</p>
									)}
								</div>
							</div>
						)}
						{selectedCategories?.diameter && (
							<div className="col-md-4 px-1">
								<div className="form-group weight-column position-relative">
									<label htmlFor="length">Diameter</label>
									<input
										type="number"
										id="length"
										min={0.1}
										onKeyDown={validateFloatNumber}
										value={selectedItem?.diameter}
										onChange={(e) =>
											setSelectedItem({
												...selectedItem,
												diameter: e.target.valueAsNumber || undefined
											})
										}
									/>
									<p className="fabric-type-text regular-14 gray_dark_02">
										{selectedCategories?.diameter}
									</p>
									{errors.diameterError && <p className="error">{errors.diameterError}</p>}
								</div>
							</div>
						)}
						{selectedCategories?.zipperNumber && (
							<div className="col-md-4 px-1">
								<div className="form-group weight-column position-relative">
									<label htmlFor="length">Zipper number</label>
									<input
										type="number"
										id="zipperNumber"
										min={0}
										onKeyDown={validateFloatNumber}
										value={selectedItem?.zipperNumber}
										onChange={(e) =>
											setSelectedItem({
												...selectedItem,
												zipperNumber: e.target.valueAsNumber || undefined
											})
										}
									/>
									<p className="fabric-type-text regular-14 gray_dark_02">
										{selectedCategories?.zipperNumber}
									</p>
									{errors.zipperNumberError && (
										<p className="error">{errors.zipperNumberError}</p>
									)}
								</div>
							</div>
						)}
						{selectedCategories?.numberOfHole && (
							<div className="col-md-4 px-1">
								<div className="form-group weight-column position-relative">
									<label htmlFor="length">Number of hole</label>
									<input
										type="number"
										id="numberOfHole"
										min={0}
										onKeyDown={validateFloatNumber}
										value={selectedItem?.numberOfHole}
										onChange={(e) =>
											setSelectedItem({
												...selectedItem,
												numberOfHole: e.target.valueAsNumber || undefined
											})
										}
									/>
									<p className="fabric-type-text regular-14 gray_dark_02">
										{selectedCategories?.numberOfHole}
									</p>
									{errors.numberOfHoleError && (
										<p className="error">{errors.numberOfHoleError}</p>
									)}
								</div>
							</div>
						)}
					</div>
				</div>

				<div className="col-md-12">
					<div className="form-group m-0">
						<label htmlFor="trimsDetails">{title} details</label>
						<textarea
							name="trimsDetails"
							id="trimsDetails"
							placeholder="Details"
							defaultValue={''}
							value={selectedItem?.details}
							onChange={(e) =>
								setSelectedItem({
									...selectedItem,
									details: e.target.value
								})
							}
						/>
					</div>
				</div>
				<div className="col-md-12 m-0">{renderColors()}</div>
				<div className="col-md-6 pr-6">
					<div className="form-group no-shadow-react-select size36">
						<label htmlFor="fabricBase">Brand specific?</label>
						<Select
							key={_getKey()}
							onChange={setSelectedSpecificBrand}
							defaultValue={selectedSpecificBrand}
							isMulti={false}
							isDisabled={false}
							options={brands}
						/>
					</div>
				</div>
				<div className="col-md-6 pl-6">
					<div className="form-group no-shadow-react-select size36">
						<label htmlFor="priceRange">Price range</label>
						<Select
							key={_getKey()}
							onChange={setPricePoint}
							defaultValue={pricePoint}
							isMulti={false}
							isDisabled={false}
							options={pricePointList}
						/>
					</div>
				</div>
				<div className="col-md-12 m-0">
					<div className="form-group ">
						<label htmlFor="Category">Material Number</label>
						<CustomDropdown
							type="addItem"
							title={title + ' Type'}
							isFocus={true}
							onItemClick={(value) => {
								onSelectForCustomDropDown(value, MATERIAL_TAG_TYPE.MATERIAL_NUMBER);
							}}
							toolTipLength={18}
							items={materialNumberList}
							selectedItem={selectedMaterialNumber?.value}
							isAddNew={true}
							itemsLength={3}
						/>

						{errors.materialNumberError && <p className="error">{errors.materialNumberError}</p>}
					</div>
				</div>
				<div className="col-md-12">
					<div className="form-group">
						<label htmlFor="description">Remarks</label>
						<textarea
							name="description"
							id="description"
							placeholder="Select"
							defaultValue={''}
							value={selectedItem?.description}
							onChange={(e) =>
								setSelectedItem({
									...selectedItem,
									description: e.target.value
								})
							}
						/>
					</div>
				</div>
			</div>
		);
	};

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" centered className="new-matarial-add-popup">
			<LoaderComponent loading={isLoading}>
				<div className="common-popup new-fabric-popup">
					<Modal.Header closeButton>
						<Modal.Title className="w-100">
							<div className="popup-tilte d-flex align-items-center justify-content-between">
								<h3 className="semibold-16 mb-0">
									{renderFrom !== enumObj.DESIGNS ? viewType : ''} {title}
								</h3>
							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body scroll-y-label">
							<div className="container px-0">
								<div className="row">
									{renderFrom === enumObj.DESIGNS ? (
										<div className="col-md-12 pr-10 mt-3">
											{TrimsOrAccessoriesRender()}
										</div>
									) : (
										<>
											<div className="col-md-12">
												<div className="common-fragment">
													<div className="dashboard-container material-images-uplodaer">
														<div className="presentations-tab">
															<div className="presentations-upload-image-container">
																<UploadImage
																	document={getImageData(
																		multipleImageData,
																		docType.MATERIAL_FEATURE_IMAGE
																	)}
																	title="Front & Feature image (_F)"
																	docType={docType.MATERIAL_FEATURE_IMAGE}
																	removeImage={removeImage}
																	singleImageUpload={singleImageUpload}
																/>

																<UploadImage
																	document={getImageData(
																		multipleImageData,
																		docType.MATERIAL_DETAILS_IMAGE
																	)}
																	title="Back (_B)"
																	docType={docType.MATERIAL_DETAILS_IMAGE}
																	removeImage={removeImage}
																	singleImageUpload={singleImageUpload}
																/>
																<div className="dashboard-container material-images-uplodaer d-flex align-items-center justify-content-center">
																	<div className="presentations-tab">
																		<div className="inline-upload text-center">
																			<label htmlFor="multipleUploadParent">
																				Upload all
																			</label>
																			<input
																				type="file"
																				className="file-upload"
																				id="multipleUploadParent"
																				name="image1"
																				onClick={(e) =>
																					(e.target.value = null)
																				}
																				onChange={(e) =>
																					onFileUpload(e)
																				}
																				accept="image/*"
																				multiple={true}
																			/>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="col-md-6 pr-10 mt-3">
												{TrimsOrAccessoriesRender()}
											</div>
											<div className="col-md-6 pl-10 mt-3">
												<div className="row">
													<div className="col-md-12">
														<p className="semibold-14 mb-2">SUPPLIER</p>
													</div>
													<div className="col-md-12">
														<div className="form-group">
															<label htmlFor="supplier">Supplier</label>
															<CustomDropdown
																type="addItem"
																title={'Supplier'}
																onItemClick={onItemClick}
																items={suppliers}
																selectedItem={selectedSupplier?.value}
															/>
															{errors.supplierError && (
																<p className="error">
																	{errors.supplierError}
																</p>
															)}
														</div>
													</div>

													{isShowSupplier && (
														<>
															<div className="col-md-12">
																<div className="form-group">
																	<label htmlFor="refNumber">
																		Supplier ref number
																	</label>
																	<input
																		type="text"
																		autoComplete="off"
																		id="refNumber"
																		className="form-control"
																		aria-label="Text input with dropdown button"
																		placeholder=""
																		value={referenceNumber}
																		onChange={(e) =>
																			setReferenceNumber(e.target.value)
																		}
																	/>
																</div>
															</div>

															<div className="col-md-6 pr-6">
																<div className="form-group">
																	<label htmlFor="price">Unite price</label>
																	<div className="d-flex f-consumption">
																		<input
																			type="number"
																			id="price"
																			className="form-control"
																			aria-label="Text input with dropdown button"
																			placeholder="$"
																			onChange={(e) =>
																				setPrice(
																					e.target.valueAsNumber
																				)
																			}
																			value={price}
																			min={0}
																			onKeyDown={validateFloatNumber}
																		/>
																		<select
																			style={{ display: 'block' }}
																			value={pricePerUnit}
																			onChange={(e) =>
																				setPricePerUnit(
																					e.target.value
																				)
																			}
																		>
																			<option value="">Unit</option>
																			{allUnitTypes.map((unit) => {
																				return (
																					<option
																						value={unit.value}
																						key={unit.value}
																					>
																						{unit.label}
																					</option>
																				);
																			})}
																		</select>
																	</div>
																</div>
															</div>
															<div className="col-md-3 px-1">
																<div className="form-group">
																	<label htmlFor="lead">Lead time</label>
																	<input
																		type="number"
																		id="lead"
																		placeholder="Days"
																		onChange={(e) =>
																			setLeadTimeInDays(
																				e.target.valueAsNumber
																			)
																		}
																		value={leadTimeInDays}
																		min={0}
																		onKeyDown={validateFloatNumber}
																	/>
																</div>
															</div>
															<div className="col-md-3 pl-6">
																<div className="form-group">
																	<label htmlFor="MOQ">MOQ</label>
																	<input
																		type="number"
																		id="MOQ"
																		value={moq}
																		onChange={(e) =>
																			setMoq(e.target.valueAsNumber)
																		}
																		min={0}
																		onKeyDown={validateFloatNumber}
																	/>
																</div>
															</div>

															<div className="col-md-12">
																<div className="form-group no-shadow-react-select size36">
																	<label htmlFor="brand">Brand</label>
																	<Select
																		key={_getKey()}
																		onChange={onChangeBrandInfo}
																		isMulti
																		options={brands}
																		defaultValue={selectedBrands}
																	/>
																</div>
															</div>

															<div className="col-md-12 pr-0"></div>
														</>
													)}
												</div>
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="footer-buttons text-right">
							<button className="button outline size32" onClick={() => handleClose('Cancel')}>
								Cancel
							</button>
							<button
								disabled={isLoading}
								className="button size32 ml-2"
								onClick={() => onSubmit()}
							>
								Submit
							</button>
						</div>
					</Modal.Footer>
				</div>
			</LoaderComponent>
		</Modal>
	);
};

export default TrimsAndAccessories;
